/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {confirmOrder} from '../api'

export const useMutationConfirmOrder = createReactQueryMutationHook('confirmOrder', confirmOrder)
